/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { combineEpics, type Epic } from 'redux-observable';
import type { Action, FilterDeletedAction, DeleteFilterFailedAction } from '../state/actions.tsx';
import type { State } from '../state/types.tsx';
import deleteFilter from './delete-filter/index.tsx';
import getAssociatedItems from './get-associated-items/index.tsx';

const DeleteFiltersModalOps: Epic<
	Action,
	State,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	any,
	FilterDeletedAction | DeleteFilterFailedAction
	// @ts-expect-error - TS2769 - No overload matches this call.
> = combineEpics(deleteFilter, getAssociatedItems);
export default DeleteFiltersModalOps;
